import Chart from 'chart.js/auto';
window.Chart = Chart;

import $ from 'jquery';
window.$ = $;
window.jQuery = $;

window.AOS = require('aos');
import 'datatables.net';
import 'datatables.net-bs5';
//import 'datatables.net-responsive';
//import 'datatables.net-responsive-bs5';
//import 'datatables.net-buttons-bs5';
//import 'datatables.net-buttons/js/dataTables.buttons';
import 'jquery-serializejson';
import 'jquery-confirm';
window.lightbox = require('lightbox2/src/js/lightbox');


//window.Popper = require('@popperjs/core').default;
//require('bootstrap');
//window.bootstrap = require('bootstrap/dist/js/bootstrap.esm');
